import React from 'react';
import PropTypes from 'prop-types';
import SectionHeader from '../../../components_profiles/SectionHeader';
import Project from '../../projects/Project';
import Event from '../../events/Event';
import usePastQuestionsForUser from '../usePastQuestionsForUser';
import usePastInvitationsForUser from '../usePastInvitationsForUser';
import ProjectImages from './ProjectImages';
import EventImages from './EventImages';
import Loader from "../../../components/Loader";
import useShowMorePagination from '../shared/useShowMorePagination';
import useStableList from '../shared/useStableList';
import usePairedListComposition from '../shared/usePairedListComposition';
import ShowMoreButton from '../shared/ShowMoreButton';

PastInvitations.propTypes = {
  user: PropTypes.object.isRequired
};

export default function PastInvitations(props) {
  const {user} = props;
  const { showAll, showMore, page, pageSize, totalVisible } = useShowMorePagination();
  const pastProjects = usePastQuestionsForUser(user, { page, pageSize });
  const pastEvents = usePastInvitationsForUser(user, { page, pageSize });

  const primary = useStableList(pastProjects);
  const secondary = useStableList(pastEvents);
  const dataFetching = primary.isFetching || secondary.isFetching;

  const pastProjectsCount = primary.data.length;
  const pastEventsCount = secondary.data.length;

  function handleShowMore() { showMore(); }

  // Compute paired list composition
  const { maxSecondaryToShow: maxEventsToShow, totalExtra } = usePairedListComposition({
    primaryCount: pastProjectsCount,
    secondaryCount: pastEventsCount,
    primaryTotalCount: primary.meta && primary.meta.totalCount,
    secondaryTotalCount: secondary.meta && secondary.meta.totalCount,
    pageSize: totalVisible,
    showAll,
    isFetching: dataFetching
  });

  if (pastProjectsCount > 0 || pastEventsCount > 0) {
    return (
      <div className="space-y-4">
        <SectionHeader
          title="Past Experiences"
          subtitle="Projects and events that I partnered on in the past."
        />
        <div className="grid grid-cols-1 gap-4">
          {primary.data.map(function (project) {
            return (
              <Project
                key={project.id || project.cid}
                project={project}
              >
                <ProjectImages project={project} limit={4}/>
              </Project>
            );
          })}
          {maxEventsToShow > 0 && secondary.data.slice(0, maxEventsToShow).map(function (event) {
            return (
              <Event
                key={event.id || event.cid}
                event={event}
              >
                <EventImages event={event}/>
              </Event>
            );
          })}
          {totalExtra > 0 && !showAll && (
            <ShowMoreButton count={totalExtra} onClick={handleShowMore} disabled={dataFetching} noun="experiences" />
          )}
          {dataFetching && <Loader/>}
        </div>
      </div>
    );
  }

  return null;
}
